import React, { useState } from "react";
import "./merchant.scss";
//import useMerchant from "../../hooks/useMerchant";
import { useDispatch, useSelector } from "react-redux";
import { Edit2Icon, Form, Loader, Save } from "lucide-react";
import { apiVersion } from "../../controller/api/apiCore";
import { setMerchant } from "../../model/store/merchantReducer";
import { toast } from "react-toastify";
import moment from "moment";
function MerchantProfile() {
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [loadingPassword, setLoadingPassword] = useState(false);
  const { merchant } = useSelector((state) => state);
  const dispatch = useDispatch();
  const handleUpdateEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let body = new FormData(e.target);
      let request = await fetch(apiVersion + "/merchant/email", {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${merchant.token}`,
        },
        body,
      });
      if (request.ok) {
        let response = await request.json();
        console.log(response);
        dispatch(setMerchant(response));
        e.target.reset();
        toast.success("Email updated successfully");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setLoadingPassword(true);
    try {
      let body = new FormData(e.target);
      let request = await fetch(apiVersion + "/merchant/password", {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${merchant.token}`,
        },
        body,
      });
      if (request.ok) {
        let response = await request.json();
        dispatch(setMerchant(response));
        e.target.reset();
        toast.success("Password updated successfully");
      }
    } catch (error) {
    } finally {
      setLoadingPassword(false);
    }
  };
  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setEditLoading(true);
    try {
      let body = new FormData(e.target);
      let request = await fetch(apiVersion + "/merchant", {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${merchant.token}`,
        },
        body,
      });
      if (request.ok) {
        let response = await request.json();
        dispatch(setMerchant(response));
        e.target.reset();
        // toast.success("Password updated successfully");
      }
    } catch (error) {
    } finally {
      setEditLoading(false);
    }
  };
  return (
    <div className="merchant-profile">
      <div className="merchant-profile__con">
        <h2>Profile</h2>
        <section className="merchant-profile__con__bio-data">
          <h3>Bio Data</h3>
          <form onSubmit={handleUpdateProfile} action="">
            <div className="input-row">
              <label>
                First Name
                <input
                  className={isDisabled ? "" : "edit"}
                  disabled={isDisabled}
                  defaultValue={merchant.firstname}
                  type="text"
                  name="firstname"
                />
              </label>
              <label>
                {" "}
                Last Name
                <input
                  className={isDisabled ? "" : "edit"}
                  disabled={isDisabled}
                  defaultValue={merchant.lastname}
                  type="text"
                  name="lastname"
                />
              </label>
            </div>
            <div className="input-row">
              <label>
                Company Name
                <input
                  className={isDisabled ? "" : "edit"}
                  disabled={isDisabled}
                  defaultValue={merchant.business_name}
                  type="text"
                  name="business_name"
                />
              </label>
              <label>
                {" "}
                Date of Birth
                <input
                  className={isDisabled ? "" : "edit"}
                  disabled={isDisabled}
                  defaultValue={moment(merchant.date_of_birth).format(
                    "yyyy-MM-DD"
                  )}
                  type="date"
                  name="date_of_birth"
                />
              </label>
            </div>
            <div className="input-row">
              <label>
                Address
                <input
                  className={isDisabled ? "" : "edit"}
                  disabled={isDisabled}
                  type="text"
                  name="address"
                  defaultValue={merchant.address}
                />
              </label>
              <label>
                Email
                <input disabled type="text" value={merchant.email} />
              </label>{" "}
            </div>
            <div className="input-row">
              <label>
                Phone
                <input
                  className={isDisabled ? "" : "edit"}
                  disabled={isDisabled}
                  name="phone_number"
                  type="text"
                  defaultValue={merchant.phone_number}
                />
              </label>{" "}
              <label>
                Sex
                <select
                  name="sex"
                  defaultValue={merchant.sex}
                  disabled={isDisabled}
                  className={isDisabled ? "" : "edit"}
                >
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </label>
            </div>
            <div className="input-row">
              <label>
                CAC No
                <input disabled type="text" value={merchant.cac_number} />
              </label>{" "}
              <label>
                REG No
                <input
                  value={merchant.registration_number}
                  disabled
                  type="text"
                />
              </label>
            </div>

            <div className="button-row">
              {!isDisabled && (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setIsDisabled(true);
                  }}
                >
                  Cancel
                </button>
              )}
              <button
                onClick={(e) => {
                  if (isDisabled) e.preventDefault();
                  setIsDisabled(false);
                }}
              >
                {" "}
                {isDisabled ? <Edit2Icon /> : <Save />}{" "}
                {isDisabled ? "Edit" : editLoading ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </section>

        <section className="merchant-profile__con__email">
          <h3>Change Email</h3>
          <form onSubmit={handleUpdateEmail}>
            <label>
              New Email
              <input name="email" type="email" />
            </label>
            <label>
              Current Password
              <input name="password" type="password" />
            </label>
            <button disabled={loading}>
              {loading ? (
                <>
                  <Loader /> Please wait ...
                </>
              ) : (
                "Update Email"
              )}
            </button>
          </form>
        </section>
        <section className="merchant-profile__con__email">
          <h3>Change Password</h3>
          <form onSubmit={handleUpdatePassword}>
            <label>
              Current Password
              <input name="oldPassword" type="password" />
            </label>
            <label>
              New Password
              <input name="newPassword" type="password" />
            </label>
            <button disabled={loadingPassword}>
              {loadingPassword ? (
                <>
                  <Loader /> Please wait ...
                </>
              ) : (
                "Change Password"
              )}
            </button>
          </form>
        </section>
      </div>
    </div>
  );
}

export default MerchantProfile;
